module.exports = __webpack_public_path__ + "static/assets/2598837e0a24e0d170ed53318b9b797a.png";